<aside class="usage-guidelines" aria-label="Test usage warning">
  <div class="usage-guidelines-icon">
    <svg
      role="img"
      aria-label="Important"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <path d="M12 9v4M12 17h.01"></path>
      <path d="M10.3 3.9L2.6 17.2a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"></path>
    </svg>
  </div>
  <div class="usage-guidelines-content">
    <div class="usage-guidelines-title">
      <strong>TelQ tests and test numbers are for your company's internal use only</strong>
    </div>
    <ul>
      <li><strong>No reselling.</strong> Do not offer TelQ tests or test results to third parties.</li>
      <li>
        <strong>No escalation.</strong> Never escalate a test number or test result to your supplier — especially after a fake DLR or a failed call.
        Use a number from your live traffic instead.
      </li>
      <li>
        <strong>No whitelisting or blacklisting.</strong> Do not whitelist, blacklist, specially route or reuse test numbers outside the TelQ
        platform.
      </li>
    </ul>
    <p>
      Misuse is a material breach of the Terms and leads to a financial penalty; escalating test numbers may also violate GDPR.
      <a [href]="usageGuidelinesUrl" target="_blank" rel="noopener noreferrer">Read the Usage Guidelines</a>
    </p>
  </div>
</aside>
